"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionHeading from "@/components/ui/SectionHeading";
import Reveal from "@/components/ui/Reveal";
import Icon from "@/components/ui/Icon";

const screens = [
  {
    label: "Master App",
    desc: "Enter the User Code and request a connection with the User device.",
    icon: "MonitorSmartphone",
  },
  {
    label: "User App",
    desc: "Grant permission to allow the Master to connect, view, and control the device.",
    icon: "Smartphone",
  },
  {
    label: "Super Admin Dashboard",
    desc: "Manage Master and User sessions, access permissions, and session activity.",
    icon: "LayoutDashboard",
  },
  {
    label: "Connected Session",
    desc: "The Master can view the User device screen in real time and remotely control it after permission is granted.",
    icon: "ScreenShare",
  },
];

export default function ProductScreens() {
  return (
    <section className="section-py overflow-hidden bg-accent/40">
      <div className="container-px mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Product Screens"
          title="A closer look at the Mobilink experience"
          subtitle="Explore the User Application, Master Application, Super Admin Dashboard, and connected Master-to-User experience."
        />
      </div>

      <Reveal delay={0.1}>
        <div className="container-px mx-auto mt-14 max-w-5xl">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={24}
            slidesPerView={1.15}
            centeredSlides
            loop
            autoplay={{ delay: 3200, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            breakpoints={{
              640: { slidesPerView: 1.5 },
              1024: { slidesPerView: 2.4 },
            }}
            className="!pb-14"
          >
            {screens.map((screen) => (
              <SwiperSlide key={screen.label}>
                <div className="flex aspect-[4/3] flex-col items-center justify-center gap-4 rounded-3xl border border-hairline bg-white p-10 text-center shadow-[0_20px_40px_-20px_rgba(31,41,55,0.12)]">
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-accent text-primary">
                    <Icon name={screen.icon} className="h-8 w-8" />
                  </div>
                  <h3 className="text-lg font-semibold text-ink">{screen.label}</h3>
                  <p className="max-w-xs text-sm leading-relaxed text-muted">{screen.desc}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Reveal>

      <style jsx global>{`
        .swiper-pagination-bullet-active {
          background: var(--color-primary) !important;
        }
      `}</style>
    </section>
  );
}
